import { TextField } from "formik-material-ui";
import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import firebase from "firebase";
import {
  Button,
  CircularProgress,
  Container,
  CssBaseline,
  Grid,
  Typography,
} from "@material-ui/core";
import { FunctionsSharp } from "@material-ui/icons";

function EditTimer() {
  const [timer, setTimer] = useState(null);

  useEffect(() => {
    if (timer == null) {
      firebase
        .database()
        .ref("EditPage/timer")
        .once("value")
        .then((res) => {
            const dateFormat = res.val()===0?new Date():new Date(res.val())
            setTimer(dateFormat.toLocaleString());
            
        });
    }
  }, [timer]);


  function dateConverter(dateString){
      console.log(timer.date)
        const am_pm = dateString[dateString.length-2]+dateString[dateString.length-1];
        console.log(am_pm)
        let arr,arr2
        if(am_pm.toUpperCase() == "AM" || am_pm.toUpperCase() == "PM"){
          //year month day 5/21/2021, 12:19:00 PM

          arr = dateString
          arr = arr.slice(0,-1).slice(0,-1)
          console.log(arr)
          arr2 = arr.split(",")[1].slice(1, ).slice(0,-1).split(":")
          arr2 = [
            parseInt(arr2[0])<10? "0"+arr2[0]:arr2[0],
          arr2[1],
           arr2[2]
          ].join(":")
          arr =  arr.split(",")[0].split("/")
          arr = [ 
          arr[2]<10?"0"+arr[2]:arr[2],
          arr[0]<10?"0"+arr[0]:arr[0],
          arr[1]<10?"0"+arr[1]:arr[1]
        ]
          arr = arr.join("-")
   
    

          let result = arr+"T"+arr2 
          console.log(result)
          return result

        }
        else{
          arr = dateString.split(" ").filter((el,indx)=> indx<=2).map(el=>el.replace(".","")).reverse().join("-")
          arr2 = dateString.split(" ")[3]
          return arr+"T"+arr2
        }
         
        
      
  }

  function handleSubmit(values) {
 
    const timeStamp = new Date(values.date) + ""
    console.log(values)
    firebase.database().ref('EditPage/timer').set(timeStamp).then(()=>{window.location.reload(false)})
  }

  if (timer == null) {
    return <CircularProgress />;
  }

  return (
    <div>
      <Container style={{ width: "80%", padding: "20px" }}>
        <Grid container alignItems="center" direction="column">
          <CssBaseline />
          <Grid container direction="column" alignItems="center">
            <Typography variant="h5" color="textPrimary">
              Ispunite formu kako biste ste postavili Timer za odbrojavanje
            </Typography>

            <Formik
              initialValues={{date:dateConverter(timer)}}
              onSubmit={(values) => {
                handleSubmit(values);
              }}
            >
              <Form>
                <Field name="date" type="datetime-local" component={TextField} style={{width:"100%"}}/>


                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{ width: "50%", marginTop: "20px" }}
                >
                  Spremi Promjene
                </Button>
              </Form>
            </Formik>
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default EditTimer;
